var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mpx-view',{staticClass:"wrapper-label-rule",on:{"tap":_vm.handleShowRuleModal}},[_c('div',{staticClass:"label-rule-text"},[_vm._v("活动")]),_c('div',{staticClass:"label-rule-text"},[_vm._v("规则")])])}
var staticRenderFns = []

export { render, staticRenderFns }